import React from "react"

import { TSocialMediaLink } from "@/types/app"
import { cn } from "@/lib/utils"
import {
  FooterBottom,
  FooterTopCard,
  IFooterTopCardProps,
} from "@/components/ui/atoms"

import { TNavItem } from "../../organisms"

interface IFooterProps {
  footerBottomLinks: TNavItem[]
  socialMediaLinks: TSocialMediaLink[]
  footerTopCards: Array<IFooterTopCardProps>
}

const Footer = React.forwardRef<HTMLDivElement, IFooterProps>(
  ({ footerTopCards, footerBottomLinks, socialMediaLinks, ...props }, ref) => {
    return (
      <footer className={cn("footer bg-neutral-200")} ref={ref} {...props}>
        <div className="container justify-center pb-7 pt-10 md:flex md:gap-6 lg:py-12">
          {footerTopCards.map((topCard) => {
            return (
              <FooterTopCard
                key={topCard.title}
                className="mb-6 md:mb-0"
                {...topCard}
              />
            )
          })}
        </div>
        <div className="bg-neutral-100 px-5 md:px-8 xl:px-12">
          <FooterBottom
            socialMediaLinks={socialMediaLinks}
            links={footerBottomLinks}
          />
        </div>
      </footer>
    )
  }
)
Footer.displayName = "Footer"

export { Footer, type IFooterProps }
